import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "turahtid_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (i) => `${i.product_id}__${i.size}`;

  function addItem(item) {
    setItems((prev) => {
      const idx = prev.findIndex((i) => lineKey(i) === lineKey(item));
      if (idx >= 0) {
        const next = [...prev];
        const maxStock = item.maxStock ?? next[idx].maxStock ?? 99;
        next[idx] = { ...next[idx], qty: Math.min(next[idx].qty + item.qty, maxStock) };
        return next;
      }
      return [...prev, item];
    });
    setDrawerOpen(true);
  }

  function updateQty(key, qty) {
    setItems((prev) =>
      prev
        .map((i) => (lineKey(i) === key ? { ...i, qty: Math.max(1, Math.min(qty, i.maxStock ?? 99)) } : i))
        .filter((i) => i.qty > 0)
    );
  }

  function removeItem(key) {
    setItems((prev) => prev.filter((i) => lineKey(i) !== key));
  }

  function clear() {
    setItems([]);
  }

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price_cents * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, lineKey, drawerOpen, setDrawerOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
